import { create, show, useModal } from "@ebay/nice-modal-react";

import ConfirmationModal from "ds/components/ConfirmationModal";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";

type SessionsConfirmationModalProps = {
  sessionId: string;
  userId: string;

  confirmationCallback: () => void;
  isCurrentSession: boolean;
};

const SessionsConfirmationModal = create(function SessionsConfirmationModal(
  props: SessionsConfirmationModalProps
) {
  const { sessionId, userId, confirmationCallback, isCurrentSession } = props;

  const modal = useModal();

  const handleConfirmation = () => {
    confirmationCallback();
    modal.hide();
  };

  return (
    <ConfirmationModal
      title={isCurrentSession ? "Log out of your session" : "Session deactivation"}
      onConfirm={handleConfirmation}
      confirmationButtonLabel={isCurrentSession ? "Log out" : "Deactivate"}
      confirmationButtonVariant="dangerPrimary"
    >
      <ConfirmationModalMessage>
        {isCurrentSession ? (
          <>
            Do you want to log out of your <strong>current session</strong> ({sessionId})?
          </>
        ) : (
          <>
            Do you want to deactivate the session <strong>{userId}</strong> ({sessionId})?
          </>
        )}
      </ConfirmationModalMessage>
    </ConfirmationModal>
  );
});

export const showSessionsConfirmationModal = (props: SessionsConfirmationModalProps) =>
  show(SessionsConfirmationModal, props);
